module.exports = __webpack_public_path__ + "media/visual-poetry.3a6e10ec.mp4";